import "swiper/css";

type Props = {
    name: string,
    title: string,
    text: string,
    avatarUrl?: string,
    profileUrl?: string,
    className?: string,
    dimmed?: boolean,
}

export default function TestimonialCard({ name, title, text, profileUrl, avatarUrl, dimmed = false }: Props) {
    return <div className="flex flex-col items-center">
        <div className={mc("m-auto w-full max-w-[360px] h-[120px] border-2 border-brand rounded-md bg-light shadow-[0px_0px_8px_16px_var(--color-light)] transition-color duration-500 ease-in-out", {
            'border-brand-light text-brand-light': dimmed,
        })}>
            <div className="flex flex-row justify-start items-center w-full h-full p-4 self-center gap-4">
                <img src={avatarUrl} loading="lazy" className={mc("object-contain object-center rounded-full h-full aspect-square shadow-sm transition-opacity duration-500 ease-in-out", {
                    'opacity-50': dimmed,
                })}/>
                <div className="flex flex-col justify-start h-full uppercase font-medium gap-1">
                    <h3>{title}</h3>
                    <a href={profileUrl} target="_blank" rel="nofollow,noindex" className="text-sm font-light hover:border-b-1 w-max">
                        <i>{name}</i>
                    </a>
                </div>
            </div>
        </div>
        <div className={mc("relative flex flex-row justify-center items-start gap-4 mt-8 pt-16 w-full md:w-3/4 h-[200px]", { 'text-brand-light': dimmed })}>
            <div className={mc(
                "absolute top-0 w-full h-full border-t-2 border-brand mask-(--mask-grid-edges-horizontal) bg-radial-[at_50%_0%] from-light via-light to-light to-transparent",
                { 'border-brand-light': dimmed, })}
            ></div>
            <p className="relative font-medium text-md text-pretty">
                <span className="before:content-['“'] after:content-['”'] before:absolute before:pr-8 before:scale-200 before:text-brand-light after:absolute after:pl-1 after:scale-200 after:text-brand-light">
                    {text}
                </span>
            </p>
        </div>
    </div>
}

